import { useEffect } from 'react';
import { Container, Paper } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { refreshLoginStatus } from '../actions/auth';
import { access } from '../domain/access';
import { useAppDispatch, useAppSelector } from '../hooks';
import Init from './Init';
import ServerError from './ServerError';

export default function App() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isInitialized, isLoggedIn, isAdmin, serverError } = useAppSelector((s) => s.auth);

  useEffect(() => {
    dispatch(refreshLoginStatus());
  }, [dispatch]);

  const decision = access(pathname, { isInitialized, isLoggedIn, isAdmin });
  const redirectTo = decision.kind === 'redirect' ? decision.to : null;

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo, { replace: true });
    }
  }, [redirectTo, navigate]);

  let content = <Outlet />;
  if (serverError.length > 0) {
    content = <ServerError messages={serverError} />;
  } else if (!isInitialized) {
    content = <Init />;
  }

  // The background is a photograph, so content needs a surface to stay readable.
  return (
    <Container maxWidth="md" disableGutters sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 4 } }}>
      <Paper
        elevation={4}
        sx={{ p: { xs: 1.5, sm: 3 }, backgroundColor: 'rgba(255, 255, 255, 0.94)' }}
      >
        {content}
      </Paper>
    </Container>
  );
}
